/* Formula-scoped guide; commerce stays with Prestige's native product form. */
(() => {
  class SoBeMousseGuide extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.setAttribute('data-ready', '');
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-rinse-choice]');
        if (choice && this.contains(choice)) this.choose(choice);
      }, options);
      this.addEventListener('keydown', (event) => {
        const choice = event.target.closest('[data-rinse-choice]');
        if (!choice) return;
        const buttons = [...this.querySelectorAll('[data-rinse-choice]')];
        let index = buttons.indexOf(choice);
        if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else return;
        event.preventDefault();
        buttons[index].focus();
        this.choose(buttons[index]);
      }, options);
      this.addEventListener('toggle', (event) => {
        if (event.target.matches('.sm-guide__video') && !event.target.open) event.target.querySelector('video')?.pause();
      }, { ...options, capture: true });
      document.addEventListener('variant:change', (event) => {
        if (!event.target.getAttribute?.('id')?.startsWith(`product-form-main-${this.dataset.productId}-`)) return;
        this.showVariant(event.detail?.variant?.id);
      }, options);
      const form = [...document.forms].find((item) => item.getAttribute('id')?.startsWith(`product-form-main-${this.dataset.productId}-`));
      this.showVariant(form?.elements.namedItem('id')?.value || this.dataset.variantId);
    }
    disconnectedCallback() { this.abortController?.abort(); }
    showVariant(id) {
      const caramel = String(id) === '43819202019479';
      this.querySelector('[data-guide-caramel]').hidden = !caramel;
      this.querySelector('[data-guide-other]').hidden = caramel;
      if (!caramel) this.querySelectorAll('video').forEach((video) => video.pause());
    }
    choose(button) {
      this.querySelectorAll('[data-rinse-choice]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelector('[data-rinse-result]').textContent = button.dataset.result;
    }
  }
  if (!customElements.get('sobe-mousse-guide')) customElements.define('sobe-mousse-guide', SoBeMousseGuide);
})();
